var exports = {
  "rf": "VoiceMessageComposerModal.module__body___dFJuNH",
  "BK": "VoiceMessageComposerModal.module__helpText___dFJuNH",
  "kc": "VoiceMessageComposerModal.module__errorText___dFJuNH",
  "mI": "VoiceMessageComposerModal.module__meta___dFJuNH",
  "sG": "VoiceMessageComposerModal.module__recordingStatus___dFJuNH",
  "ne": "VoiceMessageComposerModal.module__controls___dFJuNH",
  "hZ": "VoiceMessageComposerModal.module__buttonInner___dFJuNH",
};

module.exports = exports;
